import "@fontsource/poppins/latin-400.css"
import "@fontsource/poppins/latin-500.css"
import "@fontsource/work-sans/latin-400.css"
import "@fontsource/work-sans/latin-500.css"
import "@fontsource/work-sans/latin-900.css"
require("./src/styles/index.scss");
require("./src/styles/global.css");


// without the below the position is not reset when navigating to new page
export const onRouteUpdate = () => {
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0)
    }
}

export { default as wrapRootElement } from './src/state/ReduxWrapper';
